<div data-testid="internal-return-page" class="p-6 flex-table-page">
  <!-- Search Form -->
  <app-search-form
    data-testid="internal-return-search-form"
    [searchFormat]="searchFormat"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex gap-2">
      <app-button
        [testId]="'internal-return-column-config-btn'"
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="flex-table-section">
    <advanced-data-table
      data-testid="internal-return-table"
      #advancedTable
      [dataSource]="items()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [loading]="loading()"
      [rows]="pageSize()"
      [first]="first()"
      [totalRecords]="totalRecords()"
      scrollHeight="flex"
      [showInternalColumnConfigButton]="false"
      [sortField]="sortField()"
      [sortOrder]="sortOrder()"
      class="w-full"
      (pageChange)="onPageChange($event)"
      (sortChange)="onSortChange($event)"
    >
    <!-- Status Template -->
    <ng-template #statusTemplate let-status let-rowData="rowData">
      <p-tag
        [attr.data-testid]="
          'internal-return-status-tag-' + rowData.internalReturnNo
        "
        [value]="getStatusLabel(status)"
        [severity]="getStatusSeverity(status)"
        styleClass="status-tag"
      ></p-tag>
    </ng-template>

    <!-- Custom Template for Date Column -->
    <ng-template #customTemplate let-value let-column="column">
      @if (column?.prop === "creationDate") {
        <span class="text-sm">{{ formatDateTime(value) }}</span>
      } @else {
        {{ value }}
      }
    </ng-template>

    <!-- Actions Template -->
    <ng-template #actionsTemplate let-record>
      <div
        class="flex items-center justify-center gap-2 whitespace-nowrap w-full"
      >
        @if (canRead()) {
          <app-button
            [testId]="
              'internal-return-action-view-' + record.internalReturnNo
            "
            class="action-view"
            [label]="'common.actions.view' | translate"
            type="action"
            (emitOnClick)="onViewDetails(record); $event.stopPropagation()"
          ></app-button>
        }
      </div>
    </ng-template>
    </advanced-data-table>
  </div>
</div>

<!-- Toast Messages -->
<p-toast data-testid="internal-return-toast"></p-toast>
